import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import Feature from '../Feature';
import { useTranslations } from 'components/utilities';

const FreeKmsFeature = ({ freeKms }) => {
	const { t } = useTranslations();
	return (
		<Feature
			header={
				<Typography variant="h5">
					{freeKms}{' '}
					<Typography variant="h6" component="span">
						{t('common.KM')}
					</Typography>
				</Typography>
			}
			title={t('common.freeKms')}
		/>
	);
};

FreeKmsFeature.propTypes = {
	freeKms: PropTypes.number
};

export default FreeKmsFeature;
